import $ from "jquery";
import { getQueryParam } from "../utils/utility";

const scInputListingFilter = () => {
  const init = () => {
    popupHandler();
    handlerListingType();
    handlerPopupLocation();
    handlerPopupDate();
    handlerPopupAdditional();
    handleSubmitFilter();
    handlerDefaultValue();
  };

  const el = {
    inputFilter: ".mi-input-listing-filter",
    saveBtn: ".js-popup-save-button",
    resetBtn: ".js-popup-reset-button",
    submitBtn: ".js-submit-filter-button",
    popup: {
      item: ".mi-filter-popup",
      openBtn: ".js-open-filter-popup",
      closeBtn: ".js-close-filter-popup",
    },
    types: {
      item: ".mi-input-listing-filter-type-badge",
    },
    location: {
      badge: ".mi-filter-popup-item-body-location-options-badge",
      item: ".mi-filter-popup-item-body-location-list-item",
      text: ".mi-input-listing-filter-bar-location-content",
    },
    calendar: {
      item: ".search-calendar",
      checkInText: ".mi-input-listing-filter-bar-date-checkin-content",
      checkOutText: ".mi-input-listing-filter-bar-date-checkout-content",
    },
    beds: {
      item: ".mi-filter-popup-item-body-additional-beds-list-item",
    },
    amenities: {
      item: ".mi-filter-popup-item-body-additional-amenities-list-item",
    },
    rules: {
      item: ".mi-filter-popup-item-body-additional-terms-list-item",
    },
    listingBadges: {
      main: ".mi-input-listing-filter-additional-list",
      item: ".mi-input-listing-filter-additional-list-badge",
    },
  };

  const queryParams = {
    types: [],
    city: null,
    checkIn: null,
    checkOut: null,
    beds: null,
    amenities: [],
    rules: [],
  };

  let currentPopup = "";

  if (!$(el.inputFilter).length) return;

  const popupHandler = () => {
    // Close Popup
    $(document).on("click", el.popup.closeBtn, function () {
      $(el.popup.item).removeClass("is-visible");

      resetAdditionalSelection();
      currentPopup = "";
    });

    // Open Popup
    $(document).on("click", el.popup.openBtn, function () {
      const { popuptype } = $(this).data();

      $(el.popup.item).removeClass("is-visible");

      $(`${el.popup.item}.filter-popup-${popuptype}`).addClass("is-visible");
      currentPopup = popuptype;
    });
  };

  const handlerListingType = () => {
    $(document).on("click", el.types.item, function () {
      const type = $(this).data("type");

      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");

        // remove from array
        const index = queryParams.types.indexOf(type);
        if (index > -1) queryParams.types.splice(index, 1);
      } else {
        // select
        $(this).addClass("selected");

        // add to array (avoid duplicates)
        if (!queryParams.types.includes(type)) queryParams.types.push(type);
      }
    });
  };

  const handlerPopupLocation = () => {
    // Handle click badge
    $(document).on("click", el.location.badge, function () {
      const city = $(this).data("city");
      const $locations = $(el.location.item);

      $locations.each(function () {
        const room = $(this).data("room");

        if (!city) {
          $(this).show();
          return;
        }

        if (room.city.toLocaleLowerCase() == city.toLocaleLowerCase()) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      $(el.location.badge).removeClass("selected");
      $(this).addClass("selected");
    });

    // Handle click location
    $(document).on("click", el.location.item, function () {
      const {
        room: { area, city },
      } = $(this).data();
      queryParams.city = city;
      inputTextChanger(el.location.text, area);

      $(el.location.item).removeClass("selected");
      $(this).addClass("selected");

      $(el.popup.closeBtn).trigger("click");
    });
  };

  const handlerPopupDate = () => {
    let checkIn = null;
    let checkOut = null;

    // Handle click date
    $(document).on("click", `${el.calendar.item} .day-available`, function () {
      const { formattedDate } = $(this).data();
      const [day, month, year] = formattedDate.split("-");
      const isoDate = `${year}-${month}-${day}`;
      const clicked = new Date(isoDate);

      const $days = $(`${el.calendar.item} .day-available`);

      // Helper: parse date from day element
      const getDateFromEl = (el) => {
        const { formattedDate } = $(el).data();
        const [d, m, y] = formattedDate.split("-");
        return new Date(`${y}-${m}-${d}`);
      };

      // Helper: clear all selection classes
      const clearClasses = () => {
        $days.removeClass("selected checkin checkout in-between");
      };
      clearClasses();

      // First click set check-in
      if (!checkIn) {
        checkIn = clicked;
        checkOut = null;
        $days.removeClass("selected checkin checkout");
        $(this).addClass("selected checkin");
        return;
      }

      // Second click set check-out (must be after check-in)
      if (!checkOut) {
        if (clicked <= checkIn) {
          // clicked before check-in reset as new check-in
          checkIn = clicked;
          clearClasses();
          $(this).addClass("selected checkin");
        } else {
          checkOut = clicked;
          clearClasses();

          // Mark check-in and check-out
          $days.each(function () {
            const date = getDateFromEl(this);
            if (+date === +checkIn) $(this).addClass("selected checkin");
            else if (+date === +checkOut) $(this).addClass("selected checkout");
            else if (date > checkIn && date < checkOut)
              $(this).addClass("in-between");
          });
        }
        return;
      }

      // Third click reset everything and start new selection
      checkIn = clicked;
      checkOut = null;
      $days.removeClass("selected checkin checkout");
      $(this).addClass("selected checkin");
    });

    const formatForText = (date) =>
      date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

    // Handle click save
    $(document).on("click", el.saveBtn, function () {
      if (currentPopup == "date") {
        const $messageBox = $(".message-box");
        if (!checkIn) {
          $messageBox.empty();
          $messageBox.append(
            '<p class="error text-danger">Please select check-in date</p>'
          );
        }

        if (!checkOut) {
          $messageBox.empty();
          $messageBox.append(
            '<p class="error text-danger">Please select check-out date</p>'
          );
        }

        inputTextChanger(el.calendar.checkInText, formatForText(checkIn));
        inputTextChanger(el.calendar.checkOutText, formatForText(checkOut));

        queryParams.checkIn = checkIn?.toISOString().split("T")[0] || null;
        queryParams.checkOut = checkOut?.toISOString().split("T")[0] || null;

        $messageBox.empty();

        $(el.popup.closeBtn).trigger("click");
      }
    });

    // Handle hover highlight before selecting check-out
    $(document).on(
      "mouseenter",
      `${el.calendar.item} .day-available`,
      function () {
        if (!checkIn || checkOut) return; // Only highlight on first selection

        const { formattedDate } = $(this).data();
        const [d, m, y] = formattedDate.split("-");
        const hovered = new Date(`${y}-${m}-${d}`);

        const $days = $(`${el.calendar.item} .day-available`);

        // Remove temporary highlight
        $days.removeClass("in-between");

        // If hover is before check-in, do nothing
        if (hovered <= checkIn) return;

        // Add highlight between check-in and hovered date
        $days.each(function () {
          const { formattedDate: fd } = $(this).data();
          const [dd, mm, yy] = fd.split("-");
          const date = new Date(`${yy}-${mm}-${dd}`);

          if (date > checkIn && date < hovered) {
            $(this).addClass("in-between");
          }
        });
      }
    );

    // Clear highlight on mouse leave from calendar container
    $(document).on("mouseleave", el.calendar.item, function () {
      if (!checkOut) {
        // only clear temp highlights when selecting check-out
        $(`${el.calendar.item} .day-available`).removeClass("in-between");
      }
    });
  };

  const tempValue = {
    beds: queryParams.beds,
    amenities: [...queryParams.amenities],
    rules: [...queryParams.rules],
  };

  const handlerPopupAdditional = () => {
    // Handler click beds
    $(document).on("click", el.beds.item, function () {
      const value = $(this).data("value");
      const isSelected = $(this).hasClass("selected");

      if (isSelected) {
        $(this).removeClass("selected");
        tempValue.beds = null;
        // queryParams.beds = null;
        return;
      }

      $(el.beds.item).removeClass("selected");
      $(this).addClass("selected");

      tempValue.beds = value;
      // queryParams.beds = value;
    });

    // Handler click amenities
    $(document).on("click", el.amenities.item, function () {
      const value = $(this).data("value");

      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");

        // remove from array
        const index = tempValue.amenities.indexOf(value);
        if (index > -1) tempValue.amenities.splice(index, 1);
      } else {
        // select
        $(this).addClass("selected");

        // add to array (avoid duplicates)
        if (!tempValue.amenities.includes(value))
          tempValue.amenities.push(value);
      }
    });

    // Handler click rules
    $(document).on("click", el.rules.item, function () {
      const value = $(this).data("value");

      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");

        // remove from array
        const index = tempValue.rules.indexOf(value);
        if (index > -1) tempValue.rules.splice(index, 1);
      } else {
        // select
        $(this).addClass("selected");

        // add to array (avoid duplicates)
        if (!tempValue.rules.includes(value)) tempValue.rules.push(value);
      }
    });

    // Handle click save
    $(document).on("click", el.saveBtn, function () {
      if (currentPopup == "additional") {
        queryParams.beds = tempValue.beds;
        queryParams.amenities = [
          // eslint-disable-next-line
          ...new Set([...tempValue.amenities]),
        ];

        queryParams.rules = [
          // eslint-disable-next-line
          ...new Set([...tempValue.rules]),
        ];

        const additionalData = $(el.inputFilter).data("additional");

        const mergedArray = [
          ...tempValue.amenities,
          ...tempValue.rules,
          tempValue.beds,
        ].filter(Boolean);

        if (!mergedArray.length) {
          $(el.listingBadges.item).remove();
        }

        const $container = $(el.listingBadges.main);

        // Remove DOM badges that are no longer selected
        $container.children().each(function () {
          const val = $(this).data("value");
          if (!mergedArray.includes(val)) {
            $(this).remove();
          }
        });

        const getLabel = (item) => {
          const amenity = Object.values(additionalData.amenities).find(
            (t) => t.term_slug === item
          );
          if (amenity) return amenity.term_name;

          const rule = additionalData.rules.find((r) => r.value === item);
          if (rule) return rule.label;

          const bed = additionalData.beds.find((b) => b.value === item);
          if (bed) return bed.label;

          return item;
        };

        // Show the list
        mergedArray.forEach((item) => {
          const label = getLabel(item);

          const existingBadge = $container.children(`[data-value="${item}"]`);

          // Not append with same value
          if (existingBadge.length) return;

          const $badge = $(`
            <span class="mi-input-listing-filter-additional-list-badge" data-value="${item}">
              ${label ?? ""}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" d="M10.0001 18.3327C14.6025 18.3327 18.3334 14.6017 18.3334 9.99935C18.3334 5.39698 14.6025 1.66602 10.0001 1.66602C5.39771 1.66602 1.66675 5.39698 1.66675 9.99935C1.66675 14.6017 5.39771 18.3327 10.0001 18.3327Z" fill="currentColor"/>
                <path d="M10.8834 10.0008L12.8 8.08411C13.0417 7.84245 13.0417 7.44245 12.8 7.20078C12.5584 6.95911 12.1584 6.95911 11.9167 7.20078L10 9.11745L8.08338 7.20078C7.84172 6.95911 7.44172 6.95911 7.20005 7.20078C6.95838 7.44245 6.95838 7.84245 7.20005 8.08411L9.11671 10.0008L7.20005 11.9174C6.95838 12.1591 6.95838 12.5591 7.20005 12.8008C7.32505 12.9258 7.48338 12.9841 7.64172 12.9841C7.80005 12.9841 7.95838 12.9258 8.08338 12.8008L10 10.8841L11.9167 12.8008C12.0417 12.9258 12.2 12.9841 12.3584 12.9841C12.5167 12.9841 12.675 12.9258 12.8 12.8008C13.0417 12.5591 13.0417 12.1591 12.8 11.9174L10.8834 10.0008Z" fill="currentColor"/>
              </svg>
            </span>
          `);
          $container.append($badge);
        });

        $(el.popup.item).removeClass("is-visible");
        currentPopup = "";
      }
    });

    // Handle click reset
    $(document).on("click", el.resetBtn, function () {
      if (currentPopup == "additional") {
        // Reset temp
        tempValue.beds = null;
        tempValue.amenities = [];
        tempValue.rules = [];

        // Reset query params so old values don't merge back
        queryParams.beds = null;
        queryParams.amenities = [];
        queryParams.rules = [];

        // Remove UI selections
        $(el.beds.item).removeClass("selected");
        $(el.amenities.item).removeClass("selected");
        $(el.rules.item).removeClass("selected");

        // Reset Selected Badge
        $(el.listingBadges.item).remove();

        $(el.popup.closeBtn).trigger("click");
      }
    });

    // Handle remove additional
    $(document).on("click", el.listingBadges.item, function () {
      const value = $(this).data("value");

      if (queryParams.beds == value) {
        queryParams.beds = null;
        $(el.beds.item).removeClass("selected");
      }

      queryParams.amenities = queryParams.amenities.filter(
        (amenity) => amenity !== value
      );
      queryParams.rules = queryParams.rules.filter((rule) => rule !== value);

      tempValue.beds = queryParams.beds;
      tempValue.amenities = [...queryParams.amenities];
      tempValue.rules = [...queryParams.rules];

      const $selectedAmenities = $(el.amenities.item).filter(".selected");

      $selectedAmenities.each(function () {
        const amenityValue = $(this).data("value");
        if (amenityValue == value) {
          $(this).removeClass("selected");
        }
      });

      const $selectedRules = $(el.rules.item).filter(".selected");

      $selectedRules.each(function () {
        const amenityValue = $(this).data("value");
        if (amenityValue == value) {
          $(this).removeClass("selected");
        }
      });

      $(this).remove();
    });
  };

  const resetAdditionalSelection = () => {
    // Reset beds
    $(el.beds.item).removeClass("selected");
    if (queryParams.beds) {
      $(el.beds.item + `[data-value="${queryParams.beds}"]`).addClass(
        "selected"
      );
    }

    // Reset amenities
    $(el.amenities.item).removeClass("selected");
    queryParams.amenities.forEach((val) => {
      $(el.amenities.item + `[data-value="${val}"]`).addClass("selected");
    });

    // Reset rules
    $(el.rules.item).removeClass("selected");
    queryParams.rules.forEach((val) => {
      $(el.rules.item + `[data-value="${val}"]`).addClass("selected");
    });

    // Reset tempValue
    tempValue.beds = queryParams.beds;
    tempValue.amenities = [...queryParams.amenities];
    tempValue.rules = [...queryParams.rules];
  };

  const inputTextChanger = (selector, text) => {
    $(selector)
      .contents()
      .filter(function () {
        return this.nodeType === Node.TEXT_NODE;
      })
      .last()
      .replaceWith(` ${text}`);
  };

  const handleSubmitFilter = () => {
    $(document).on("click", el.submitBtn, function () {
      const params = new URLSearchParams();

      Object.entries(queryParams).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          // join array values with comma
          params.set(key, value.join(","));
        } else if (value !== null && value !== undefined && value !== "") {
          // add normal key/value
          params.set(key, value);
        }
      });

      // build full URL
      const fullUrl = `/rooms?${params.toString()}`;

      // redirect
      window.location.href = fullUrl;
    });
  };

  const handlerDefaultValue = () => {
    // Default Value
    $(window).on("load", function () {
      // Listing Types
      const $itemTypes = $(el.types.item).filter(".selected");
      $itemTypes.each(function () {
        const type = $(this).data("type");
        queryParams.types.push(type);
      });

      // Location
      const defaultLocation = getQueryParam("city");
      queryParams.city = defaultLocation;

      // Checkin & Checkout Date
      const checkInDate = getQueryParam("checkIn");
      const checkOutDate = getQueryParam("checkOut");
      queryParams.checkIn = checkInDate;
      queryParams.checkOut = checkOutDate;

      const $dateListCalendar = $(`${el.calendar.item} .day-available`);

      function formatDate(dateStr) {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      }

      const formattedCheckIn = formatDate(checkInDate);
      const formattedCheckOut = formatDate(checkOutDate);

      $dateListCalendar.each(function () {
        const date = $(this).data("formatted-date");

        // Skip if no date
        if (!date) return;

        // Convert to comparable Date object
        const [d, m, y] = date.split("-");
        const current = new Date(`${y}-${m}-${d}`);
        const checkIn = new Date(checkInDate);
        const checkOut = new Date(checkOutDate);

        // Apply classes
        if (date === formattedCheckIn || date === formattedCheckOut) {
          $(this).addClass("selected");
        } else if (current > checkIn && current < checkOut) {
          $(this).addClass("in-between");
        }
      });

      // Additional Bed
      const $itemBed = $(el.beds.item).filter(".selected");
      $itemBed.each(function () {
        const value = $(this).data("value");
        queryParams.beds = value;
      });

      // Additional Amenities
      const $itemAmenities = $(el.amenities.item).filter(".selected");
      $itemAmenities.each(function () {
        const value = $(this).data("value");
        queryParams.amenities.push(value);
      });

      // Additional Rules
      const $itemRules = $(el.rules.item).filter(".selected");
      $itemRules.each(function () {
        const value = $(this).data("value");
        queryParams.rules.push(value);
      });
    });
  };

  init();
};

try {
  scInputListingFilter();
} catch (e) {
  console.error("Shortcode Input Listing Filter : ", e);
}
